import { c as _c } from "react/compiler-runtime";
import { DIGITAL_PRODUCT_API } from 'modules/digital-product/api';
import { DigitalProductInterface } from 'modules/digital-product/types/digital-product-interface';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { digitalProductDependencies } from '../constants/digital-product-dependencies';
export function useDigitalProduct(digitalProductId) {
  const $ = _c(4);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== digitalProductId) {
    t1 = () => [`${DIGITAL_PRODUCT_API}/${digitalProductId}`, ...digitalProductDependencies];
    $[1] = digitalProductId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return useControlledSwr(t1, fetcher, t2, !!user && !!digitalProductId);
}